/**
 * Build a direct link to a form with optional pre-filled parameters
 * 
 * @param {string} baseUrl - The form's base public URL
 * @param {Object} params - Query parameters (e.g. { eventType: 123 })
 * @returns {string}
 */
export function buildFormLink(baseUrl, params = {}) {
    if (!baseUrl) {
        return '';
    }
    
    const keys = Object.keys(params);
    if (keys.length === 0) {
        return baseUrl;
    }
    
    const queryString = new URLSearchParams(params).toString();
    return `${baseUrl}?${queryString}`;
}

/**
 * Build a link with event type parameter
 */
export function buildEventTypeLink(baseUrl, eventTypeId) {
    return buildFormLink(baseUrl, { eventType: eventTypeId });
}

/**
 * Build a link with bookable resource parameter
 */
export function buildBookableResourceLink(baseUrl, bookableResourceId) {
    return buildFormLink(baseUrl, { bookableResource: bookableResourceId });
}

/**
 * Build a link with instance parameter
 */
export function buildInstanceLink(baseUrl, instanceId) {
    return buildFormLink(baseUrl, { instance: instanceId });
}
